// extracted by mini-css-extract-plugin
export var logo = "_ll-2";
export var logoWrapper = "_ll-1";
export var strip = "_ll-0";